/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Ws_S3Inputs */

const en_mk_tut_ws_s3 = /** @type {(inputs: Mk_Tut_Ws_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Press **Create**. Every division you ticked immediately gets a chat channel and one agent with sensible built-in instructions.`)
};

const id_mk_tut_ws_s3 = /** @type {(inputs: Mk_Tut_Ws_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekan **Buat**. Tiap divisi yang dicentang langsung mendapat channel obrolan dan satu agen dengan instruksi kerja bawaan.`)
};

/**
* | output |
* | --- |
* | "Press **Create**. Every division you ticked immediately gets a chat channel and one agent with sensible built-in instructions." |
*
* @param {Mk_Tut_Ws_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_ws_s3 = /** @type {((inputs?: Mk_Tut_Ws_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Ws_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_ws_s3(inputs)
	return en_mk_tut_ws_s3(inputs)
});